import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import SelectImportProfilePanel from './SelectImportProfilePanel';
import { fetchImportHistoryStatuses, fetchImportHistory } from 'redux/importHistory/ImportHistoryActions';

const mapStateToProps = ({ profiles: { fetchingProfilesList } }) => ({
  fetchingProfilesList
});

const mapDispatchToProps = dispatch => ({
  importHistoryActions: bindActionCreators({ fetchImportHistoryStatuses, fetchImportHistory }, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(SelectImportProfilePanel);



// WEBPACK FOOTER //
// ./src/components/importData/comp/selectImportProfilePanel/SelectImportProfilePanelConnector.js